import { render, staticRenderFns } from "./Return-button-container.vue?vue&type=template&id=2ddb09b0&scoped=true&"
import script from "./Return-button-container.vue?vue&type=script&lang=js&"
export * from "./Return-button-container.vue?vue&type=script&lang=js&"
import style0 from "./Return-button-container.vue?vue&type=style&index=0&id=2ddb09b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb09b0",
  null
  
)

export default component.exports